/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : DetailsLogTab.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomTabsV2 from "../../common/tabs/CustomTabsV2";
import LogsTab from "./LogsTab";
import EEForm from "./EEForm";
import RenderAsKeyValue from "../customComponents/RenderAsKeyValue";
import { convertUtcToTimeZone } from "../../../../utils/convertUtcToTimeZone";
import SWMForm from "./SWMForm";
import CustomFormTextFieldV2 from "../../common/textField/CustomFormTextFieldV2";
import CustomSelectV2 from "../../common/select/CustomSelectV2";
import MultiselectConnectorV2 from "../../common/connectors/MultiselectConnectorV2";
import AttributesForm from "../../../../pages/labcar/Attributes/AttributesForm";

const getZoneDetailsLabel = (zoneDetails) => {
  if (Array.isArray(zoneDetails)) {
    const zoneNames = zoneDetails
      .map((item) => item?.zone_name || item?.zone?.zone_name)
      .filter(Boolean);

    return zoneNames.length > 0 ? zoneNames.join(", ") : "-";
  }

  return zoneDetails?.zone_name || zoneDetails?.zone?.zone_name || "-";
};

function DetailsLogTab({
  title,
  getZoneEECountList,
  openEditDetailsDialog,
  setOpenEditDetailsDialog,
  handleEEComponentReplace,
  selectedEEComponentReplaceDetails,
  setSelectedEEComponentReplaceDetails,
  vsOptionsList,
  setIsLinkSoftwareModulesScreen,
  selectedZone,
  selectedZoneDetails,
  selectedEEComponentDetails,
  getEEComponentsList,
  getSWModulesList,
  selectedProjectDetails,
  selectedSingleVariantDetails,
  variantOptionList,
  supplierOptionsList,
  logData,
  getLogsData,
  selectedComponent,
  zone_name,
  ChangeLogsList,
  type,
  totalLogsCount,
  selectedVariantsMany,
  handleSWModuleReplace,
  selectedSWModuleReplaceDetails,
  setSelectedSWModuleReplaceDetails,
  vfOptionsList,
}) {
  const [expandlogs, setExpandLogs] = useState(false);
  const vsSelectedVariants =
    selectedComponent?.variant_ids && selectedComponent?.variant_ids?.length > 0
      ? selectedComponent?.variant_ids
      : selectedSingleVariantDetails?.variant_id != null
        ? [selectedSingleVariantDetails?.variant_id]
        : [];
  const vsVariantOptions = (variantOptionList || []).filter((opt) =>
    vsSelectedVariants.map(String).includes(String(opt?.value)),
  );

  const handleExpandLogs = (value) => {
    setExpandLogs(value);
  };
  useEffect(() => {
    getLogsData({
      ee_id: logData?.ee_id,
      ...(type === "SWM" ? { swm_id: logData?.swm_id } : {}),
      pageNo: 1,
      pageSize: 25,
    });
  }, []);
  return (
    <Box sx={{ width: "100%" }}>
      <CustomTabsV2
        tabs={[
          {
            name: "Details",
            count: "",
            content: (
              <Box sx={{ p: 0 }}>
                <Box sx={{ p: 0 }}>
                  {type === "VS" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <CustomFormTextFieldV2
                        size={"small"}
                        label={"Assembly No"}
                        type={"text"}
                        fldType={"textR"}
                        value={selectedComponent?.assembly_number || ""}
                        setValue={() => {}}
                        disabled
                      />
                      <CustomSelectV2
                        size={"small"}
                        label={"Select Vehicle System"}
                        optionsList={[
                          {
                            value: selectedComponent?.name || "",
                            label: selectedComponent?.name || "",
                          },
                        ]}
                        selectedValue={selectedComponent?.name || ""}
                        handleOnChange={() => {}}
                        disabled
                      />
                      <CustomFormTextFieldV2
                        size={"small"}
                        label={"Description"}
                        type={"text"}
                        fldType={"text"}
                        value={selectedComponent?.description || ""}
                        setValue={() => {}}
                        disabled
                      />
                      <MultiselectConnectorV2
                        size={"small"}
                        label={"Select Suppliers"}
                        optionsList={(selectedComponent?.suppliers || []).map(
                          (item) => ({
                            value: item,
                            label: item,
                          }),
                        )}
                        selectedValues={selectedComponent?.suppliers || []}
                        setSelectedValues={() => {}}
                        placeholder={false}
                        disabled
                      />
                      <MultiselectConnectorV2
                        size={"small"}
                        label={"Select Variants"}
                        optionsList={vsVariantOptions}
                        selectedValues={vsSelectedVariants}
                        setSelectedValues={() => {}}
                        placeholder={false}
                        disabled
                      />
                    </Box>
                  )}
                  {type === "VC" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <CustomFormTextFieldV2
                        size={"small"}
                        label={"Component No"}
                        type={"text"}
                        fldType={"textR"}
                        value={selectedComponent?.component_number || ""}
                        setValue={() => {}}
                        disabled
                      />
                      <CustomSelectV2
                        size={"small"}
                        label={"Select Vehicle Component"}
                        optionsList={[
                          {
                            value: selectedComponent?.name || "",
                            label: selectedComponent?.name || "",
                          },
                        ]}
                        selectedValue={selectedComponent?.name || ""}
                        handleOnChange={() => {}}
                        disabled
                      />
                      <CustomFormTextFieldV2
                        size={"small"}
                        label={"Description"}
                        type={"text"}
                        fldType={"text"}
                        value={selectedComponent?.description || ""}
                        setValue={() => {}}
                        disabled
                      />
                      <MultiselectConnectorV2
                        size={"small"}
                        label={"Select Suppliers"}
                        optionsList={(selectedComponent?.suppliers || []).map(
                          (item) => ({
                            value: item,
                            label: item,
                          }),
                        )}
                        selectedValues={selectedComponent?.suppliers || []}
                        setSelectedValues={() => {}}
                        placeholder={false}
                        disabled
                      />
                      <MultiselectConnectorV2
                        size={"small"}
                        label={"Select Variants"}
                        optionsList={(variantOptionList || []).filter((opt) =>
                          (selectedComponent?.variant_ids &&
                          selectedComponent?.variant_ids?.length > 0
                            ? selectedComponent?.variant_ids
                            : selectedSingleVariantDetails?.variant_id != null
                              ? [selectedSingleVariantDetails?.variant_id]
                              : []
                          )
                            .map(String)
                            .includes(String(opt?.value)),
                        )}
                        selectedValues={
                          selectedComponent?.variant_ids &&
                          selectedComponent?.variant_ids?.length > 0
                            ? selectedComponent?.variant_ids
                            : selectedSingleVariantDetails?.variant_id != null
                              ? [selectedSingleVariantDetails?.variant_id]
                              : []
                        }
                        setSelectedValues={() => {}}
                        placeholder={false}
                        disabled
                      />
                    </Box>
                  )}

                  {type === "EE" && (
                    <EEForm
                      title={title}
                      getZoneEECountList={getZoneEECountList}
                      openEEComponentReplaceDialog={openEditDetailsDialog}
                      setOpenEEComponentReplaceDialog={setOpenEditDetailsDialog}
                      handleEEComponentReplace={handleEEComponentReplace}
                      selectedEEComponentReplaceDetails={
                        selectedEEComponentReplaceDetails
                      }
                      setSelectedEEComponentReplaceDetails={
                        setSelectedEEComponentReplaceDetails
                      }
                      vsOptionsList={vsOptionsList}
                      setIsLinkSoftwareModulesScreen={
                        setIsLinkSoftwareModulesScreen
                      }
                      selectedZone={selectedZone}
                      selectedZoneDetails={selectedZoneDetails}
                      selectedEEComponentDetails={selectedEEComponentDetails}
                      getEEComponentsList={getEEComponentsList}
                      getSWModulesList={getSWModulesList}
                      selectedProjectDetails={selectedProjectDetails}
                      selectedSingleVariantDetails={
                        selectedSingleVariantDetails
                      }
                      variantOptionList={variantOptionList}
                      supplierOptionsList={supplierOptionsList}
                      disableFields={[
                        "assemblyNo",
                        "supplierName",
                        "version",
                        "description",
                        "summary",
                        "vehicleSystems",
                        "asilClass",
                        "variants",
                        "reason",
                      ]}
                    />
                  )}

                  {type === "SWM" && (
                    <SWMForm
                      supplierOptionsList={supplierOptionsList}
                      title={"Replace SW Module"}
                      selectedVariantsMany={selectedVariantsMany}
                      variantOptionList={variantOptionList}
                      selectedProjectDetails={selectedProjectDetails}
                      selectedEEComponentDetails={selectedEEComponentDetails}
                      openSWModuleReplaceDialog={openEditDetailsDialog}
                      setOpenSWModuleReplaceDialog={setOpenEditDetailsDialog}
                      handleSWModuleReplace={handleSWModuleReplace}
                      selectedSWModuleReplaceDetails={
                        selectedSWModuleReplaceDetails
                      }
                      setSelectedSWModuleReplaceDetails={selectedComponent}
                      vfOptionsList={vfOptionsList}
                      setIsLinkSoftwareModulesScreen={
                        setIsLinkSoftwareModulesScreen
                      }
                      selectedZone={selectedZone}
                      getSWModulesList={getSWModulesList}
                      selectedSingleVariantDetails={
                        selectedSingleVariantDetails
                      }
                      disableFields={[
                        "number",
                        "version",
                        "description",
                        "summary",
                        "supplierName",
                        "vehicleFunction",
                      ]}
                    />
                  )}
                </Box>
                <Box>
                  <Typography>
                    <RenderAsKeyValue
                      keyValues={{
                        "Zone Details":
                          zone_name ||
                          getZoneDetailsLabel(selectedComponent?.zone_details),
                        "Created at": convertUtcToTimeZone(
                          selectedComponent?.created_at,
                        ),
                        "Modified at": convertUtcToTimeZone(
                          selectedComponent?.updated_at,
                        ),
                      }}
                    />
                  </Typography>
                </Box>
              </Box>
            ),
          },
          {
            name: "Log",
            content: (
              <LogsTab
                logs={ChangeLogsList}
                expanded={expandlogs}
                setExpanded={handleExpandLogs}
              />
            ),
            count: totalLogsCount || 0,
          },
          {
            name: "Attribute",
            content: (
              <Box>
                <AttributesForm
                  type={"VIEW"}
                  attributeFromApi={selectedComponent?.attributes || []}
                  getFormData={() => {}}
                />
              </Box>
            ),
          },
        ]}
      />
    </Box>
  );
}

export default DetailsLogTab;
